module.exports = __webpack_public_path__ + "static/media/Ally_web_5.be2e9318.jpg";